import { useCallback } from "react";

import { GqlClient } from "~/__generated__";
import useCurrentClient from "~/modules/client/hooks/useCurrentClient";

export default function useCreateClientUrl(): (
    to?: string,
    options?: { client?: GqlClient; relative?: boolean },
) => string {
    const currentClient = useCurrentClient();
    return useCallback(
        (to = "", { client, relative = false }: { client?: GqlClient; relative?: boolean } = {}) => {
            const slug = client ? client.slug : currentClient?.client.slug;
            const base = relative ? "c/" : "/c/";
            return `${base}${slug}/${to}`;
        },
        [currentClient],
    );
}
